export default __webpack_public_path__ + "2f67d5f52c4658631d16d8c8d6bb2bc3.png";